import React from 'react';
import './Brands.css';

const brands = ["ClawGen AI", "ClawGen", "ClawGen", "ClawGen", "ClawGen"];

const Brands = () => {
  return (
    <div className="brand-cloud">
      {brands.map((brand, index) => (
        <div key={index} className="brand-logo">
          {brand}
        </div>
      ))}
    </div>
  );
};

export default Brands;
